// STATUS
export const validStatuses = ['Valid'];

// RESOLUTION LEVEL
export const validResolutionLevels = ['DPV', 'Premise'];
